import { call, put, takeLatest, select } from "redux-saga/effects";
import { PROYECT, api_get, api_post } from "services/api";
import { setSnackbar } from "redux/actions/search/searchActions";
import { BLUE_RGB, GREEN_RGB } from "utils/colorsTheme";
import { orderArray } from "helpers/orderArray";

const CLEAR_PRICES_SECTION = "CLEAR_PRICES_SECTION";
// Prices
const LOAD_PRICES_PRICES_SECTION = "LOAD_PRICES_PRICES_SECTION";
const SET_PRICES_PRICES_SECTION = "SET_PRICES_PRICES_SECTION";
const ERROR_PRICES_PRICES_SECTION = "ERROR_PRICES_PRICES_SECTION";

// Files
const LOAD_FILES_PRICES_SECTION = "LOAD_FILES_PRICES_SECTION";
const SET_FILES_PRICES_SECTION = "SET_FILES_PRICES_SECTION";
const ERROR_FILES_PRICES_SECTION = "ERROR_FILES_PRICES_SECTION";
const CLEAR_FILES_PRICES_SECTION = "CLEAR_FILES_PRICES_SECTION";

// filters
const SET_FILTERS_PRICES_SECTION = "SET_FILTERS_PRICES_SECTION";

// config
const SET_CONFIG_TAB_PRICES_SECTION = "SET_CONFIG_TAB_PRICES_SECTION";
const SET_CONFIG_PAGE_PRICES_SECTION = "SET_CONFIG_PAGE_PRICES_SECTION";
const SET_CONFIG_PAGE_SIZE_PRICES_SECTION =
  "SET_CONFIG_PAGE_SIZE_PRICES_SECTION";
const SET_CONFIG_SORTED_PRICES_SECTION = "SET_CONFIG_SORTED_PRICES_SECTION";
const SET_CONFIG_FILTERED_PRICES_SECTION = "SET_CONFIG_FILTERED_PRICES_SECTION";

const INITIAL_STATE = {
  prices: [],
  graphs: [],
  isLoading: false,

  files: {
    isLoadingFiles: false,
    inserted: 0,
    ignored: [],
    showLast: false,
  },

  // filters
  company: [], // multi-select empresas (para TableInputs)
  station: [], // multi-select plantas (para TableInputs)
  // Gps
  isLoadingGps: false,
  // config
  config: {
    tab: 0,
    page: 0,
    pageSize: 50,
    sorted: [],
    filtered: [],
  },
};

const pricesSectionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // units
    case LOAD_PRICES_PRICES_SECTION:
      return {
        ...state,
        prices: [],
        graphs: [],
        isLoading: true,
      };
    case SET_PRICES_PRICES_SECTION:
      return {
        ...state,
        prices: payload.prices,
        graphs: payload.graphs,
        isLoading: false,
      };
    case ERROR_PRICES_PRICES_SECTION:
      return {
        ...state,
        isLoading: false,
      };

    // files
    case LOAD_FILES_PRICES_SECTION:
      return {
        ...state,
        files: {
          ...state.files,
          isLoadingFiles: true,
          inserted: 0,
          ignored: [],
        },
      };
    case SET_FILES_PRICES_SECTION:
      return {
        ...state,
        files: {
          ...state.files,
          isLoadingFiles: false,
          inserted: payload.inserted,
          ignored: payload.ignored,
          showLast: true,
        },
      };
    case CLEAR_FILES_PRICES_SECTION:
      return {
        ...state,
        files: {
          ...state.files,
          showLast: false,
        },
      };
    case ERROR_FILES_PRICES_SECTION:
      return {
        ...state,
        files: {
          ...state.files,
          isLoadingFiles: false,
        },
      };

    // filters
    case SET_FILTERS_PRICES_SECTION:
      return {
        ...state,
        [payload.key]: payload.data,
      };

    //config
    case SET_CONFIG_TAB_PRICES_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          tab: payload,
        },
      };
    case SET_CONFIG_FILTERED_PRICES_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };
    case SET_CONFIG_PAGE_PRICES_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };
    case SET_CONFIG_PAGE_SIZE_PRICES_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };
    case SET_CONFIG_SORTED_PRICES_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        },
      };

    // general
    case CLEAR_PRICES_SECTION:
      return {
        ...state,
        ...INITIAL_STATE,
      };

    default:
      return state;
  }
};

// Actions
// Prices
function getPrices(stations) {
  return {
    type: LOAD_PRICES_PRICES_SECTION,
    payload: {
      stations,
    },
  };
}
// files
function loadFiles(file, type, startDate, endDate, formData) {
  return {
    type: LOAD_FILES_PRICES_SECTION,
    payload: {
      file,
      type,
      startDate,
      endDate,
      formData,
    },
  };
}
function clearFiles() {
  return {
    type: CLEAR_FILES_PRICES_SECTION,
  };
}

// Filters
function setPricesSectionFilters(key = "", data) {
  return {
    type: SET_FILTERS_PRICES_SECTION,
    payload: { key, data },
  };
}

// config
function setConfigTab(tab) {
  return {
    type: SET_CONFIG_TAB_PRICES_SECTION,
    payload: tab,
  };
}
function setConfigFilter(filter) {
  return {
    type: SET_CONFIG_FILTERED_PRICES_SECTION,
    payload: filter,
  };
}
function setConfigPage(page) {
  return {
    type: SET_CONFIG_PAGE_PRICES_SECTION,
    payload: page,
  };
}
function setConfigPageSize(pageSize) {
  return {
    type: SET_CONFIG_PAGE_SIZE_PRICES_SECTION,
    payload: pageSize,
  };
}
function setConfigSorted(sorted) {
  return {
    type: SET_CONFIG_SORTED_PRICES_SECTION,
    payload: sorted,
  };
}

// sagas
function* fetchPrices(action) {
  const {
    payload: { stations = [] },
  } = action;

  const token = yield select((state) => state.login.token);
  const auth = { headers: { authorization: `${token}` } };
  const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/prices?`;
  const urlStations = (stations || []).map((s) => `stations=${s.value}`).join("&");
  const url = `${baseUrl}${urlStations}`;

  try {
    const { prices, companies } = yield call(api_get, url, auth);
    const newGraphs = companies.map((company) => {
      return {
        ...company,
        stations: company.stations.map((station) => {
          return {
            ...station,
            correlation: {
              ...station.correlation,
              datasets: station.correlation.datasets
                ? station.correlation.datasets.map((dataset, index) => ({
                    ...dataset,
                    fill: false,
                    backgroundColor: index ? GREEN_RGB : BLUE_RGB,
                    borderColor: index ? GREEN_RGB : BLUE_RGB,
                  }))
                : [],
            },
          };
        }),
      };
    });

    yield put({
      type: SET_PRICES_PRICES_SECTION,
      payload: {
        prices: orderArray(prices, "station"),
        graphs: newGraphs,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_PRICES_PRICES_SECTION,
    });
    yield put(setSnackbar(message, "danger"));
  }
}
function* sendFile(action) {
  const {
    payload: { file, type, startDate, endDate, formData: formDataCall },
  } = action;
  const formData = new FormData();
  formData.append(formDataCall, file);
  const token = yield select((state) => state.login.token);
  const auth = {
    headers: {
      authorization: `${token}`,
      "Content-Type": "multipart/form-data",
    },
  };
  const url = `${process.env.REACT_APP_URL}${PROYECT}/${type}?start=${startDate}&end=${endDate}`;

  try {
    const response = yield call(api_post, url, formData, auth);

    yield put({
      type: SET_FILES_PRICES_SECTION,
      payload: {
        inserted: response.inserted,
        ignored: response.ignored,
      },
    });
  } catch (message) {
    yield put({
      type: ERROR_FILES_PRICES_SECTION,
    });
    yield put(setSnackbar(message, "danger"));
  }
}

function* pricesSectionSaga() {
  yield takeLatest(LOAD_PRICES_PRICES_SECTION, fetchPrices);
  yield takeLatest(LOAD_FILES_PRICES_SECTION, sendFile);
}

export {
  // reducer
  pricesSectionReducer,
  // actions
  getPrices,
  loadFiles,
  clearFiles,
  setConfigTab,
  setConfigFilter,
  setConfigPage,
  setConfigPageSize,
  setConfigSorted,
  setPricesSectionFilters,
  // saga
  pricesSectionSaga,
};
